export type KaggleTier =
  | "novice"
  | "contributor"
  | "expert"
  | "master"
  | "grandmaster";

export const kaggleTierLabels: Record<KaggleTier, string> = {
  novice: "Novice",
  contributor: "Contributor",
  expert: "Expert",
  master: "Master",
  grandmaster: "Grand Master",
};

export const kaggleTierOrder: KaggleTier[] = [
  "novice",
  "contributor",
  "expert",
  "master",
  "grandmaster",
];
